export const Errors = {
  FieldRequired: 'Το πεδίο είναι υποχρεωτικό',
  CompanyNameRequired: 'Το όνομα της εταιρείας είναι υποχρεωτικό',
  EstablishmentDateRequired: 'Η ημερομηνία ίδρυσης είναι υποχρεωτική',
  TaxIdentificationNumberRequired: 'Το ΑΦΜ είναι υποχρεωτικό',
  CompanySizeRequired: 'Το μέγεθος της εταιρείας είναι υποχρεωτικό',
  ActivityCodeRequired: 'Το ΚΑΔ Κύριας Δραστηριότητας είναι υποχρεωτικό',
  LegalFormRequired: 'Η νομική μορφή είναι υποχρεωτική',
  StreetNumberRequired: 'Η οδός είναι υποχρεωτική',
  PostalCodeRequired: 'Ο ταχυδρομικός κώδικας είναι υποχρεωτικός',
  TaxOfficeRequired: 'Η ΔΟΥ είναι υποχρεωτική',
  PhoneRequired: 'Το τηλέφωνο είναι υποχρεωτικό',
  EmailRequired: 'Το email είναι υποχρεωτικό',
  FirstNameRequired: 'Το όνομα είναι υποχρεωτικό',
  LastNameRequired: 'Το επώνυμο είναι υποχρεωτικό',
  OccupationRequired: 'Το επάγγελμα είναι υποχρεωτικό',
  MobilePhoneRequired: 'Το κινητό τηλέφωνο είναι υποχρεωτικό',
  RegionRequired: 'Η Περιοχή Έδρας είναι υποχρεωτική',
  GenericFormError:
    'Υπήρξε κάποιο σφάλμα κατά την αποθήκευση. Δοκιμάστε ξανά ή ανανεώστε τη σελίδα.',
  GenericRetrievalError:
    'Κάτι πήγε στραβά κατά τη φόρτωση των δεδομένων. Παρακαλώ δοκιμάστε ξανά αργότερα.',
  UploadError: 'Σφάλμα κατά τη μεταφόρτωση',
  WrongFileUploadRequiredFields:
    'Μη έγκυρη συμπλήρωση πεδίων. Βεβαιωθείτε ότι έχετε εισάγει σωστά τα υποχρεωτικά πεδία του αρχείου.',
  GenericError: 'Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε ξανά αργότερα.',
};
